import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  select(event) {
    const id = event.currentTarget.dataset.tabsIdParam
    this.tabTargets.forEach(t => {
      const active = t.dataset.tabsIdParam === id
      t.classList.toggle("bg-brand-700", active)
      t.classList.toggle("text-white", active)
      t.classList.toggle("shadow-md", active)
      t.classList.toggle("text-ink-700", !active)
    })
    this.panelTargets.forEach(p => {
      const active = p.dataset.tabsIdParam === id
      p.classList.toggle("hidden", !active)
      if (active) {
        p.classList.add("opacity-0")
        requestAnimationFrame(() => p.classList.remove("opacity-0"))
      }
    })
  }
}
